import React from 'react'
import { connect } from 'react-redux'
import { LOGOUT_REQUEST } from '../../actions/actions'
import { Link } from 'react-router'

const style = { color: '#292929' }

const LogoutMenuItem = ({ dispatch, sidebarIsOpen }) => {
  const dispatchLogout = ((dispatch, action) => () =>
    dispatch(action))(dispatch, {
    type: LOGOUT_REQUEST
  })

  return (
    <Link to="#" className="logout-item">
      <div
        className="vertical-menu-item"
        onClick={dispatchLogout}
        style={style}
      >
        <i className="fa fa-sign-out" aria-hidden="true" />
        {sidebarIsOpen && <span style={{ marginRight: 20 }}>خروج</span>}
      </div>
    </Link>
  )
}

export default connect(state => ({ sidebarIsOpen: state.sidebar.isOpen }))(
  LogoutMenuItem
)



// WEBPACK FOOTER //
// ./src/components/common/LogoutMenuItem.js